import { useState } from 'react';
import Footer from '../../components/feature/Footer';
import Modal from '../../components/base/Modal';
import ContactFormModal from '../../components/feature/ContactFormModal';
import WhatsAppButton from '../../components/base/WhatsAppButton';
import VoxDayHeroSection from './components/VoxDayHeroSection';
import WhatIsVoxDaySection from './components/WhatIsVoxDaySection';
import ExperienceSection from './components/ExperienceSection';
import ForWhoSection from './components/ForWhoSection';
import AboutVox2youSection from './components/AboutVox2youSection';
import HowItWorksSection from './components/HowItWorksSection';
import InvestmentSection from './components/InvestmentSection';
import FinalCallSection from './components/FinalCallSection';

export default function VoxDay() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [hasPartialData, setHasPartialData] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [hasCompletedAdditionalFields, setHasCompletedAdditionalFields] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => {
    setIsContactModalOpen(false);
    setTimeout(() => {
      setHasPartialData(false);
      setShowAdditionalFields(false);
      setHasCompletedAdditionalFields(false);
    }, 300);
  };

  return (
    <div className="min-h-screen">
      <main>
        <VoxDayHeroSection onOpenModal={openContactModal} />
        <WhatIsVoxDaySection />
        <ExperienceSection />
        <ForWhoSection />
        <AboutVox2youSection />
        <HowItWorksSection />
        <InvestmentSection onOpenModal={openContactModal} />
        <FinalCallSection onOpenModal={openContactModal} />
      </main>
      <Footer />
      
      <WhatsAppButton onClick={openContactModal} />
      
      <Modal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal}
        hasPartialData={hasPartialData}
        showAdditionalFields={showAdditionalFields}
        hasCompletedAdditionalFields={hasCompletedAdditionalFields}
      >
        <ContactFormModal 
          onSuccess={closeContactModal}
          onPartialDataChange={setHasPartialData}
          onAdditionalFieldsChange={setShowAdditionalFields}
          onCompletedAdditionalFieldsChange={setHasCompletedAdditionalFields}
        />
      </Modal>
    </div>
  );
}
